"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.sessionTimingIntegration = void 0;

var _integration = require("../integration.js");

var _time = require("../utils-hoist/time.js");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

const INTEGRATION_NAME = 'SessionTiming';

const _sessionTimingIntegration = () => {
  const startTime = (0, _time.timestampInSeconds)() * 1000;
  return {
    name: INTEGRATION_NAME,

    processEvent(event) {
      const now = (0, _time.timestampInSeconds)() * 1000;
      return _objectSpread(_objectSpread({}, event), {}, {
        extra: _objectSpread(_objectSpread({}, event.extra), {}, {
          ['session:start']: startTime,
          ['session:duration']: now - startTime,
          ['session:end']: now
        })
      });
    }

  };
};
/**
 * This function adds duration since the sessionTimingIntegration was initialized
 * till the time event was sent.
 *
 * @deprecated This integration is deprecated and will be removed in the next major version of the SDK.
 * To capture session durations alongside events, use [Context](https://docs.sentry.io/platforms/javascript/enriching-events/context/) (`Sentry.setContext()`).
 */


const sessionTimingIntegration = exports.sessionTimingIntegration = (0, _integration.defineIntegration)(_sessionTimingIntegration);